<template>
  <div class="rsvp-edit" v-if="edited !== null">
    <span class="opoli-logo icon-font" v-if="brandCode === 'op'"></span>
    <!-- <span class="pts-logo icon-font" v-if="brandCode === 'pts'"></span> -->
    <span class="s2l-logo icon-font" v-if="brandCode === 's2l'"></span>
    <div class="logo">
      <img src="../../assets/img/gosedan-log.png" v-if="brandCode === 'gs'"/>
      <img src="../../assets/img/pts-logo.png" v-if="brandCode === 'pts'"/>
    </div>

    <div class="row">
      <div class="large-12 column">
        <div class="rsvp-edit-container">
          <h3 class="title margin-v-z medium-padding-h-s padding-b-m">{{ $t('rsvpEdit.editingRsvp') }} {{ edited.id }}</h3>
          <div v-if="mtech.enabled" class="mtech-note">{{ $t('rsvpEdit.forRsvpInfo') }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="large-7 column padding-r-s medium-padding-h-s">
        <div class="card">
          <h4 class="margin-t-z margin-b-s">{{ $t('rsvpEdit.rsvpDetails') }}</h4>
          <!-- PICKUP -->
          <div :class="['label-value border-top', {disabled:isD2DAirportPickup}]" @click="updateLocation(true)">
            <div class="label"><i class="fa fa-map-marker-alt fa-fw"></i><span>{{ $t('rsvpEdit.pickupLoc') }}</span></div>
            <div class="value">{{ getAddress(edited.pickup) }}</div>
            <i class="fa fa-edit" v-if="!mtech.enabled && !isD2DAirportPickup && !edited.isLyft"></i>
          </div>
          <div class="label-value add-extra-stop" @click="addExtraStop" v-if="(!edited.extraStops || !edited.extraStops.length) && !charter.enabled && !optinEnabled && !mtech.enabled && false">
            <a><i class="fas fa-plus"></i> {{ $t('rsvpEdit.addExtraStop') }}</a>
          </div>
          <!-- EXTRA STOPS -->
          <div class="label-value" v-if="!optinEnabled && !mtech.enabled && false"
            v-for="(stop, index) in edited.extraStops" :key="index"
            @click="updateStopLocation(index)">
            <div class="label"><i class="fa fa-map-marker-alt fa-fw"></i><span>{{ $t('rsvpEdit.extraStop') }}</span></div>
            <div class="value">{{ getStopAddress(stop) }} &nbsp;</div>
            <i class="fa fa-edit"></i>
          </div>
          <!-- DROPOFF -->
          <div :class="['label-value', {disabled:isD2DAirportDropoff}]" @click="updateLocation(false)" v-if="!charter.enabled">
            <div class="label"><i class="fa fa-map-marker-alt fa-fw"></i><span>{{ $t('rsvpEdit.dropoffLoc') }}</span></div>
            <div class="value">{{ getAddress(edited.dropoff) }}</div>
            <i class="fa fa-edit" v-if="!mtech.enabled && !isD2DAirportDropoff && !edited.isLyft"></i>
          </div>
          <!-- PICKUP TIME -->
          <div v-bind:class="['label-value', {error: error.pickupTime}]"
            @click="openDateTimePicker(false)" v-if="!charter.enabled"> <!-- v-if="!isAirportPickup && !isAirportDropoff" -->
            <div class="label">
              <i class="far fa-clock fa-fw"></i>
              <span>{{ $t('rsvpEdit.pickupTime2') }}</span>
            </div>
            <div class="value">{{ pickupTime }}</div>
            <i class="fa fa-edit" v-if="!mtech.enabled && !edited.isLyft"></i>
          </div>
          <!-- Charter: Start Date -->
          <div v-bind:class="['label-value', {error: charterValidation.startDate, disabled:edited.isLyft}]"
            @click="openCharterDatePicker('startDate')" v-if="charter.enabled">
            <div class="label">
              <i class="far fa-clock fa-fw"></i>
              <span>{{ $t('rsvpEdit.pickupTime2') }}</span>
            </div>
            <div class="value">{{ charter.startDate }}</div>
            <i class="fa fa-edit" v-if="!mtech.enabled"></i>
          </div>
          <!-- Charter: End Date -->
          <div v-bind:class="['label-value', {error: charterValidation.endDate, disabled:edited.isLyft}]"
            @click="openCharterDatePicker('endDate')" v-if="charter.enabled">
            <div class="label">
              <i class="far fa-clock fa-fw"></i>
              <span>{{ $t('rsvpEdit.UntilWhen') }}</span>
            </div>
            <div class="value">{{ charter.endDate }}</div>
            <i class="fa fa-edit" v-if="!mtech.enabled"></i>
          </div>
          <!-- FLIGHT INFO -->
          <div v-bind:class="['label-value', {error: error.flightInfoError}]"
            v-show="(isAirportPickup || isAirportDropoff) && !edited.isLyft" @click="openDateTimePicker(true)">
            <!--openFlightInfo-->
            <div class="label"><i class="fas fa-plane fa-fw"></i><span>{{ $t('rsvpEdit.flightInfo') }}</span></div>
            <div class="value">
              <span v-if="edited.airline === null || edited.airline === 'N/A'">{{ $t('rsvpEdit.enterFlight') }}</span>
              <span v-else>{{ edited.airline }} {{ edited.flightNumber }}</span>
            </div>
            <i class="fa fa-edit" v-if="!mtech.enabled"></i>
          </div>
          <div class="row">
            <div class="small-6 column">
              <!-- PASSENGER -->
              <div class="label-value select-input">
                <div class="label"><i class="fa fa-user fa-fw"></i><span>{{ $t('rsvpEdit.pax') }}</span></div>
                <div class="value">{{ edited.passengers }}</div>
                <select v-model="passengers" @change="updatePassengers" v-if="!mtech.enabled && !edited.isLyft">
                  <option :value="n" v-for="n in 9" :key="n">{{ n }}</option>
                </select>
                <i class="fa fa-caret-down" v-if="!mtech.enabled"></i>
              </div>
            </div>
            <div class="small-6 column">
              <!-- LUGGAGE -->
              <div class="label-value border-left padding-left select-input">
                <div class="label"><i class="fas fa-suitcase fa-fw"></i><span>{{ $t('rsvpEdit.luggage') }}</span></div>
                <div class="value">{{ edited.luggage }}</div>
                <select v-model="luggage" v-if="!mtech.enabled && !edited.isLyft">
                  <option :value="n - 1" v-for="n in 19" :key="n">{{ n - 1 }}</option>
                </select>
                <i class="fa fa-caret-down" v-if="!mtech.enabled"></i>
              </div>
            </div>
          </div>
          <!-- SERVICE TYPE -->
          <div :class="['label-value', {error: error.serviceTypeError}]" @click="openServiceSelection">
            <div class="label"><i class="fa fa-car fa-fw"></i><span>{{ $t('rsvpEdit.serviceType') }}</span></div>
            <div class="value">{{ serviceLabel }} </div>
            <i class="fa fa-edit" v-if="!mtech.enabled && !edited.isLyft"></i>
          </div>
          <div class="label-value no-pointer" v-if="showOptin && !quoteLoading" :key="`opt${optinKey}`">
            <div class="opt-title">
              {{ $t('rsvpEdit.saveBySharing', {percent: services[edited.serviceCode].optinPercent}) }}
            </div>
            <div class="opt-desc">
              {{ $t('rsvpEdit.ifWeFind') }}
              <b>${{optinRefundPrice().toFixed(2)}}</b>
              {{ $t('rsvpEdit.atTheTime') }}
            </div>
            <label class="opt-check">
              <input type="checkbox" v-model="optinEnabled" />
              {{ $t('rsvpEdit.iWantToShare') }}
            </label>
          </div>
          <!-- PICKUP TYPE -->
          <div :class="{
            'label-value checkbox': true,
            checked: isMeetAndGreet || !isUSPhone || isMeetAndGreetOnly,
            disabled: !isUSPhone || isMeetAndGreetOnly
          }" v-show="isAirportPickup && isMeetAndGreetEnabled" @click="toggleMeetAndGreet">
            <div class="label"><i class="fas fa-male fa-fw"></i><span>{{ $t('rsvpEdit.pickupType') }}</span></div>
            <div class="value">
              <i class="far fa-square fa-fw unchecked"></i>
              <i class="fas fa-check-square fa-fw checked"></i>
              <span>{{ $t('rsvpEdit.mng') }} ({{ pickupFeeDisplay !== null && pickupFeeDisplay > 0 ? '$' + pickupFeeDisplay.toFixed(2) : $t('rsvpEdit.complimentary') }})</span>
            </div>
          </div>
          <!-- GUEST INFORMATION -->
          <div class="label-value" @click="showGuest">
            <div class="label"><i class="fa fa-user fa-fw"></i><span>{{ $t('rsvpEdit.guestInfo') }}</span></div>
            <div class="value">{{ guestInfo }}</div>
            <i class="fa fa-edit" v-if="!mtech.enabled && !edited.isLyft"></i>
          </div>
          <div class="row">
            <div class="small-6 column">
              <!-- WHEELCHAIR -->
              <div class="label-value select-input">
                <div class="label"><i class="fas fa-wheelchair fa-fw"></i><span>{{ $t('rsvpEdit.wheelchair') }}</span></div>
                <div class="value">{{ wheelchair ? $t('rsvpEdit.yes2') : $t('rsvpEdit.no2') }}</div>
                <select v-model="wheelchair" v-if="!mtech.enabled && !edited.isLyft">
                  <option :value="true">{{ $t('rsvpEdit.yes2') }}</option>
                  <option :value="false">{{ $t('rsvpEdit.no2') }}</option>
                </select>
                <i class="fa fa-caret-down" v-if="!mtech.enabled && !edited.isLyft"></i>
              </div>
            </div>
            <div class="small-6 column">
              <!-- SERVICE DOG -->
              <div class="label-value border-left padding-left select-input">
                <div class="label"><i class="fas fa-blind fa-fw"></i><span>{{ $t('rsvpEdit.serviceDog') }}</span></div>
                <div class="value">{{ serviceDog ? $t('rsvpEdit.yes2') : $t('rsvpEdit.no2') }}</div>
                <select v-model="serviceDog" v-if="!mtech.enabled && !edited.isLyft">
                  <option :value="true">{{ $t('rsvpEdit.yes2') }}</option>
                  <option :value="false">{{ $t('rsvpEdit.no2') }}</option>
                </select>
                <i class="fa fa-caret-down" v-if="!mtech.enabled && !edited.isLyft"></i>
              </div>
            </div>
          </div>
          <!-- DRIVER NOTES -->
          <div class="label-value" @click="showDriverNotes" v-if="!mtech.enabled || (mtech.enabled && edited.notes)">
            <div class="label"><i class="far fa-sticky-note fa-fw"></i><span>{{ $t('rsvpEdit.driverNote') }}</span></div>
            <div class="value">{{ driverNotes }}</div>
            <i class="fa fa-edit" v-if="!mtech.enabled && !edited.isLyft"></i>
          </div>
        </div>
      </div>

      <div class="large-5 column padding-l-s medium-padding-h-s medium-margin-t-s">
        <customer-info class="margin-b-m medium-margin-b-s"></customer-info>
        <transition name="slide-down">
          <pickup-info class="margin-b-m medium-margin-b-s" v-if="isAirportPickup || isAirportDropoff"></pickup-info>
        </transition>
        <payment-info></payment-info>
        <a :class="['op-btn btn-lg btn-success btn-block', {disabled: services === null}]"
          href="javascript:;" @click="confirmUpdate" v-if="!mtech.enabled">{{ $t('rsvpEdit.updateRsvp') }}</a>
        <a class="op-btn btn-lg btn-danger btn-block cancel-rsvp-btn"
          href="javascript:;" @click="showCancellation">{{ $t('rsvpEdit.cancelRsvp3') }}</a>
        <!-- <a class="cancel-btn" href="#/search" @click="back($event)">{{ $t('rsvpEdit.returnHome') }}</a> -->
        <a class="cancel-btn"  @click="backHistory">Return</a>
      </div>
    </div>

    <cancel-reservation></cancel-reservation>
    <date-time-picker @openFlightInfo="openFlightInfo"></date-time-picker>
    <driver-notes></driver-notes>
    <flight-information></flight-information>
    <guest-information></guest-information>
    <location-input></location-input>
    <service-selection></service-selection>
    <shared-alloted-time-modal ref="sharedAllowedTime"></shared-alloted-time-modal>
    <update-reservation></update-reservation>

    <!-- VALIDATION MODAL -->
    <div v-bind:class="{ 'op--modal-container': true, hide: !error.show }" @click="error.show = false">
      <div class="op--modal">
        <div class="op--modal-content">
          <div class="error-modal" @click.stop>
            <div class="title">{{ $t('rsvpEdit.missedSomething') }}</div>
            <div class="message" v-html="error.message"></div>
            <a class="op-btn btn-lg btn-block btn-success" href="javascript:;" @click="error.show = false">
              {{ $t('rsvpEdit.gotIt') }}
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- SUGGESTED TIME MODAL -->
    <div v-bind:class="{'op--modal-container':true, hide:true}"
      @click="closeSuggestedTime">
      <div class="op--modal">
        <div class="op--modal-content">
          <div class="suggested-time-box" @click.stop>
            <div class="box">
              <div class="title">{{ $t('rsvpEdit.suggestedPickupTime') }}</div>
              <p v-if="isAirportPickup">{{ $t('rsvpEdit.suggesteDesc') }}</p>
              <p v-else>{{ $t('rsvpEdit.suggesteDesc2') }}</p>
              <span class="time">{{ suggestedTime() }}</span>
              <span class="op-btn btn-lg btn-success btn-block"
                @click="applySuggestedTime">{{ $t('rsvpEdit.suggestedYes') }}</span>
              <a class="keep" @click="closeSuggestedTime">{{ $t('rsvpEdit.suggestedNo') }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script type="text/javascript">
/* global CONFIG */
import moment from 'moment-timezone'
import { isValidNumber } from 'libphonenumber-js'

import ApiQuote from '@/modules/api/edit-quote'
import featureToggle from '@/modules/api/featureToggle'

import CancelReservation from './CancelReservation'
import CustomerInfo from './CustomerInformation'
import PickupInfo from './PickupInfo'
import DateTimePicker from './DateTimePicker'
import DriverNotes from './DriverNotes'
import FlightInformation from './FlightInformation'
import GuestInformation from './GuestInformation'
import LocationInput from './LocationInput'
import PaymentInfo from './PaymentInformation'
import ServiceSelection from './ServiceSelection'
import SharedAllotedTimeModal from './SharedAllotedTimeModal'
import UpdateReservation from './UpdateReservation'

export default {
  name: 'rsvp-edit',
  components: {
    CancelReservation,
    CustomerInfo,
    PickupInfo,
    DateTimePicker,
    DriverNotes,
    FlightInformation,
    GuestInformation,
    LocationInput,
    PaymentInfo,
    ServiceSelection,
    SharedAllotedTimeModal,
    UpdateReservation
  },
  data () {
    return {
      error: {
        show: false,
        message: '',
        serviceTypeError: false,
        flightInfoError: false,
        pickupTime: false,
        lastSelectedService: ''
      },
      charterValidation: {
        startDate: '',
        endDate: ''
      },
      offsets: {},
      rerender: {
        service: true
      },
      optinKey: moment().format('x')
    }
  },
  computed: {
    original () { return this.$store.state.rsvpEdit.originalRsvp },
    edited () { return this.$store.state.rsvpEdit.editedRsvp },
    services () { return this.$store.state.rsvpEdit.serviceSelection.services },
    serviceLabel () {
      if (this.mtech.enabled) return this.original.mtechService.description || 'MTECH'
      if (!this.$store.state.rsvpEdit.editedRsvp.serviceCode) return ''

      let service = this.edited.serviceLabel
      if (this.$store.state.rsvpEdit.serviceSelection.selectedService !== null) {
        service = this.$store.state.rsvpEdit.serviceSelection.selectedService.brandedName
      }
      // if (service === 'Lyft') service = 'Prime Time Express'
      return service
    },
    pickupFeeDisplay () {
      if (this.$store.state.rsvpEdit.serviceSelection.selectedService !== null) {
        return this.$store.state.rsvpEdit.serviceSelection.selectedService.pickupFee
      }

      if (this.services !== null) {
        if (!this.services[this.edited.serviceCode]) { return 0 }
        return this.services[this.edited.serviceCode].pickupFee
      }

      return this.edited.payment.pickupFee
    },
    pickupTime () {
      let self = this
      if (this.mtech.enabled) {
        return moment(self.edited.rawPickupDate, 'YYYY-MM-DD HH:mm:ss Z').tz(this.edited.pickupTimezone).format('MMMM DD, YYYY - ' + featureToggle.timeFormat(self, false))
      }
      return moment(self.edited.pickupTime, 'MM/DD/YYYY ' + featureToggle.timeFormat(self, false)).format('MMMM DD, YYYY - ' + featureToggle.timeFormat(self, false))
    },
    flightTime () { return this.$store.state.rsvpEdit.flightInfo.flightTime },
    passengers: {
      get () { return this.edited.passengers },
      set (value) { this.$store.commit('rsvpEdit/setEditedPassenger', value) }
    },
    luggage: {
      get () { return this.edited.luggage },
      set (value) { this.$store.commit('rsvpEdit/setEditedLuggage', value) }
    },
    wheelchair: {
      get () { return this.edited.ada.wheelchair },
      set (value) { this.$store.commit('rsvpEdit/setEditedWheelchair', value) }
    },
    serviceDog: {
      get () { return this.edited.ada.serviceDog },
      set (value) { this.$store.commit('rsvpEdit/setEditedServiceDog', value) }
    },
    guestInfo () {
      if (this.edited.guest.firstName === null || this.edited.guest.firstName === '') {
        return this.$t('rsvpEdit.bookingForMyself')
      }
      return this.$t('rsvpEdit.bookingFor') + ' ' + this.edited.guest.firstName + ' ' + this.edited.guest.lastName
    },
    isMeetAndGreet () { return this.edited.pickupType === 'MeetAndGreet' },
    isMeetAndGreetEnabled () {
      let self = this
      if (self.services === null || self.edited.isLyft) return false

      let serviceCode = self.edited.serviceCode
      let service = self.services[serviceCode]
      if (!service) { return false }
      let selectedService = self.$store.state.rsvpEdit.serviceSelection.selectedService
      if (selectedService !== null) service = selectedService

      return service.meetAndGreet
    },
    isMeetAndGreetOnly () {
      let self = this
      if (self.services === null || self.edited.isLyft) return false

      let serviceCode = self.edited.serviceCode
      let service = self.services[serviceCode]
      let selectedService = self.$store.state.rsvpEdit.serviceSelection.selectedService
      if (selectedService !== null) service = selectedService

      return service.meetAndGreet && !service.curbside
    },
    isAirportPickup () { return this.edited.pickup.geofenceType === 'airport' },
    isAirportDropoff () { return this.edited.dropoff.geofenceType === 'airport' },
    driverNotes () {
      if (this.edited.notes === null || this.edited.notes === '') {
        return this.$t('rsvpEdit.addDriverNote')
      }
      return this.edited.notes
    },
    isUSPhone () {
      let userPhone = this.original.consumer.phones[0]
      userPhone = userPhone.countryCode + userPhone.phoneNumber
      return isValidNumber(userPhone, 'US') || isValidNumber(userPhone, 'CA')
    },
    showSuggestedTime () { return this.$store.state.rsvpEdit.flightInfo.suggestedTime.show },
    _suggestedTime () { return this.$store.state.rsvpEdit.flightInfo.suggestedTime.time },
    _pickupTime () { return this.$store.state.rsvpEdit.editedRsvp.pickupTime },
    _airline () { return this.$store.state.rsvpEdit.editedRsvp.airline },
    _flightNo () { return this.$store.state.rsvpEdit.editedRsvp.flightNumber },
    _serviceCode () { return this.$store.state.rsvpEdit.serviceSelection.selectedService },
    brandCode () { return this.$store.state.brandCode },
    _pickupTimeOffsets () { return this.$settings.get('PickupTimeOffsets') },
    charter () { return this.$store.state.reservation.charter },
    quoteLoading () { return this.$store.state.rsvpEdit.serviceSelection.isLoading },
    optin () { return this.$store.state.reservation.optin.leg1 },
    showOptin () {
      return this.edited.serviceCode && !!this.services && Object.keys(this.services).length &&
        !!this.services[this.edited.serviceCode] && this.services[this.edited.serviceCode].optinAllow &&
        this.sharedAllowedTime && !this.charter.enabled && !this.edited.extraStops && !this.edited.pkgId
    },
    sharedAllowedTime () {
      if (this.$settings.get('AirportStart') === this.$settings.get('AirportEnd')) return false
      if (!this.isAirportPickup) { return true }

      let selectedTime = moment()
      if (this.edited.pickupTime) {
        selectedTime = moment(this.edited.pickupTime, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
      }

      selectedTime = moment(selectedTime.format('hh:mmA'), 'hh:mmA')
      let allowTimeStart = moment(this.$settings.get('AirportStart'), 'hh:mmA')
      let allowTimeEnd = moment(this.$settings.get('AirportEnd'), 'hh:mmA')
      return parseInt(selectedTime.format('X')) >= parseInt(allowTimeStart.format('X')) &&
        parseInt(selectedTime.format('X')) <= parseInt(allowTimeEnd.format('X'))
    },
    optinEnabled: {
      get () { return this.optin.enabled },
      set (x) {
        this.$store.commit('reservation/setOptinData', {
          leg: 'leg1',
          fields: {enabled: x}
        })
      }
    },
    mtech () { return this.$store.state.reservation.mtech },
    flightStore () { return this.$store.state.flights },
    isConnectedToFlight () { return this.flightStore.edit.id === this.original.id },
    isD2DAirportPickup () {
      let target = this.flightStore.edit.target
      if (!target) return false
      if (['rsvp1', 'rsvp3'].indexOf(target) > -1) return false

      let flights = this.flightStore.selected.flights
      let airportCode = flights.oneway[0].destination.code
      if (target === 'rsvp4') airportCode = flights.return[0].destination.code
      return this.isConnectedToFlight && airportCode === this.original.pickup.airportCode
    },
    isD2DAirportDropoff () {
      let target = this.flightStore.edit.target
      if (!target) return false
      if (['rsvp2', 'rsvp4'].indexOf(target) > -1) return false

      let flights = this.flightStore.selected.flights
      let airportCode = flights.oneway[flights.oneway.length - 1].origin.code
      if (target === 'rsvp3') airportCode = flights.return[flights.return.length - 1].origin.code
      return this.isConnectedToFlight && airportCode === this.original.dropoff.airportCode
    }
  },
  methods: {
    back (event) {
      if (event) event.preventDefault()
      // let loc = window.location.href
      // let index = loc.indexOf('#')
      // window.location = loc.substring(0, index) + '#'

      // this.$root.$emit('close')
      this.$store.commit('reservation/setOptinData', {
        leg: 'leg1',
        fields: {enabled: false}
      })
      document.body.classList.remove('widget-full')
      // this.$root.$router.push('search-edit')
      // window.location.href = '#/search-edit'
      this.$root.$router.push('search')
      window.location.href = '#/search'
    },
    backHistory () {
      this.$router.go(-1)
    },
    openDateTimePicker (forFlight) {
      if (this.mtech.enabled || this.edited.isLyft) return

      this.error.pickupTime = false
      if (!forFlight) {
        this.$store.commit('rsvpEdit/setForPickupDate', true)
      }
      this.$store.commit('reservation/setCharterData', {datePicker: 'flightDate'})
      this.$store.commit('rsvpEdit/showDateTimePicker')
    },
    openFlightInfo () {
      this.error.flightInfoError = false
      this.$store.commit('rsvpEdit/showFlightInfo')
    },
    openServiceSelection () {
      if (this.mtech.enabled || this.edited.isLyft) return

      this.error.serviceTypeError = false
      this.$store.commit('rsvpEdit/showServiceSelection')
    },
    updateLocation (isPickup) {
      if (
        this.mtech.enabled ||
        (isPickup && this.isD2DAirportPickup) ||
        (!isPickup && this.isD2DAirportDropoff) ||
        this.edited.isLyft
      ) {
        return
      }

      let self = this
      self.$store.commit('rsvpEdit/setIsStop', false)
      self.$store.commit('rsvpEdit/setIsPickup', isPickup)
      self.$store.commit('rsvpEdit/showLocationInput')
    },
    updateStopLocation (index) {
      let self = this
      self.$store.commit('rsvpEdit/setIsStopIndex', index)
      self.$store.commit('rsvpEdit/setIsStop', true)
      self.$store.commit('rsvpEdit/setIsPickup', false)
      self.$store.commit('rsvpEdit/showLocationInput')
    },
    getAddress (location) {
      if (location.geofenceType === 'airport' &&
          location.geofenceName !== '') {
        let result = location.geofenceName
        if (location.terminal && location.terminal !== '' && location.terminal !== 'undefined') {
          result += ` - ${this.$t('rsvpEdit.terminal')} ${location.terminal}`
        }
        return result
      }

      let address = ''
      if (location.addressLine2 && location.addressLine2 !== '' && location.addressLine2 !== 'undefined') {
        address = address + location.addressLine2 + ' '
      }
      if (location.addressLine1) {
        address = address + location.addressLine1 + ', '
      }
      if (location.city) {
        address = address + location.city + ' '
      }
      if (location.state) {
        address = address + location.state + ' '
      }
      if (location.zip) {
        address = address + location.zip
      }

      return address
    },
    getStopAddress (location) {
      let address = ''
      if (location.address2 && location.address2 !== '' && location.address2 !== 'undefined') {
        address = address + location.address2 + ' '
      }
      if (location.address1) {
        address = address + location.address1 + ', '
      }
      if (location.city) {
        address = address + location.city + ' '
      }
      if (location.state) {
        address = address + location.state + ' '
      }
      if (location.zip) {
        address = address + location.zip
      }

      return address
    },
    toggleMeetAndGreet () {
      let self = this
      if (self.isMeetAndGreet) {
        self.$store.commit('rsvpEdit/setEditedPickupType', null)
      } else {
        self.$store.commit('rsvpEdit/setEditedPickupType', 'MeetAndGreet')
      }

      ApiQuote.updateSelectedService(self)
    },
    confirmUpdate () {
      let self = this
      // check airport pickup
      // let isAirportPickup = self.edited.pickup.geofenceType === 'airport'
      if ((self.isAirportPickup || (CONFIG.featureToggle.requiredDropoffAirport && self.isAirportDropoff)) &&
        (self.edited.airline === null || self.edited.airline === 'N/A' || self.edited.airline === '')
      ) {
        self.error.show = true
        self.error.message = this.$t('rsvpEdit.provideFlightInfo')
        self.error.flightInfoError = true
        return
      }

      // check passenger accomodation
      let service = self.$store.state.rsvpEdit.serviceSelection.selectedService
      if (!service && !self.edited.serviceCode) {
        self.error.show = true
        self.error.message = this.$t('rsvpEdit.noServiceSelected')
        self.error.pickupTime = true
        return
      }
      if (service === null) {
        service = self.services[self.edited.serviceCode]
      }
      if (service.prices.length < self.edited.passengers) {
        self.error.show = true
        self.error.message = `${this.$t('rsvpEdit.serviceAccomodate1')} ${self.edited.passengers} ${this.$t('rsvpEdit.serviceAccomodate2')}`
        self.error.serviceTypeError = true
        return
      }

      // check luggage accomodation
      if (self.edited.luggage > service.maxLuggage) {
        self.error.show = true
        self.error.message = `${this.$t('rsvpEdit.serviceAccomodate1')} ${self.edited.luggage} ${this.$t('rsvpEdit.serviceAccomodate3')}`
        self.error.serviceTypeError = true
        return
      }

      // check pickup time
      let buffer = service.bufferTime || parseInt(self.$settings.get('WebTimeBuffer'))
      let now = moment().add(buffer, 'minute')
      let pickupTimezone = self.$store.state.rsvpEdit.editedRsvp.pickupTimezone
      let pickupTime = moment.tz(self.edited.pickupTime, 'MM/DD/YYYY ' + featureToggle.timeFormat(self, false), pickupTimezone)

      if (pickupTime.isBefore(now)) {
        self.error.show = true
        let time = moment.tz(pickupTimezone)
        time.subtract(parseFloat(time.format('mm') % 5), 'minutes').add(5, 'minutes')
        self.error.message = this.$t('rsvpEdit.pickupTimeMustBeAfter', {
          time: time.add(buffer, 'minute').format('hh:mmA')
        })
        self.error.pickupTime = true
        return
      }

      if (this.charter.enabled) {
        if (!this.charter.endDate) {
          self.error.show = true
          self.error.message = this.$t('rsvpEdit.pleaseSetEnd')
          self.error.pickupTime = true
          return
        }
      }

      self.$store.commit('rsvpEdit/showUpdate')
    },
    updatePassengers () {
      ApiQuote.updateSelectedService(this)
    },
    closeSuggestedTime () { this.$store.commit('rsvpEdit/setSuggestedTimeShow', false) },
    checkSuggestedTime () {
      let rsvp = this.$store.state.rsvpEdit.editedRsvp
      if (rsvp.airlineCode && rsvp.flightNumber && rsvp.serviceCode &&
        rsvp.pickupTime !== this.suggestedTime() && this.suggestedTime() !== ''
      ) {
        this.applySuggestedTime()
        // this.$store.commit('rsvpEdit/setSuggestedTimeShow', true)
      }
    },
    suggestedTime () {
      let rsvp = this.$store.state.rsvpEdit.editedRsvp
      let flightInfo = this.$store.state.rsvpEdit.flightInfo
      if (!flightInfo.suggestedTime.time) { return '' }

      let date = moment(flightInfo.suggestedTime.time, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
      if (rsvp.pickup.geofenceType === 'airport') {
        let delay = flightInfo.suggestedTime.isDomestic ? 'ArrivalDomesticDelay' : 'ArrivalInternationalDelay'
        date.add(this.$settings.get(delay), 'minutes')
      } else if (rsvp.dropoff.geofenceType === 'airport') {
        let delay = flightInfo.suggestedTime.isDomestic ? 'DepartureDomesticBuffer' : 'DepartureInternationalBuffer'
        let eta = Math.ceil(rsvp.eta / 60)
        let btt = Math.ceil(eta * 1.15)
        let selectedService = rsvp.serviceCode
        let serviceSelection = this.$store.state.rsvpEdit.serviceSelection
        if (serviceSelection.selectedService && serviceSelection.selectedService.code) {
          selectedService = serviceSelection.selectedService.code
        }
        if (selectedService === 'shared') {
          btt = Math.ceil(eta * (1 + (this.$settings.get('OfferLimitThreshold') / 100)))
          btt = (btt - (btt % 5)) + 5
        }
        let timeDelay = Math.ceil(parseFloat(this.$settings.get(delay)))
        date.subtract(timeDelay + btt, 'minutes')
        date.subtract(parseInt(date.format('mm')) % 5, 'minutes')
      }

      if (this.offsets['a' + date.format('e')] && rsvp.dropoff.geofenceType === 'airport') {
        let found = false
        this.offsets['a' + date.format('e')].forEach(function (data, index) {
          let time = moment(date.format('HHmm'), 'HHmm')
          let start = moment(data.start, 'HHmm')
          let end = moment(data.end, 'HHmm')
          if (time.isBetween(start, end) && !found) {
            found = true
            if (data.value.indexOf('-') > -1) {
              date.subtract(data.value.substring(1, data.value.length), 'minutes')
            } else {
              date.add(data.value, 'minutes')
            }
          }
        })
      }

      return !date.isBefore(moment().add(this.$settings.get('WebTimeBuffer'), 'minutes')) ? date.format('MM/DD/YYYY ' + featureToggle.timeFormat(this, false)) : ''
    },
    applySuggestedTime () {
      this.$store.commit('rsvpEdit/setEditedPickupTime', this.suggestedTime())
      this.closeSuggestedTime()
    },
    sharedAllowedTime () {
      let rsvp = this.$store.state.rsvpEdit.editedRsvp
      if (rsvp.serviceCode !== 'shared') { return }

      let startTimeStart = moment(this.$settings.get('AirportStart'), 'hh:mm A').format('X')
      let allowTimeEnd = moment(this.$settings.get('AirportEnd'), 'hh:mm A').format('X')
      let currentTime = moment(rsvp.pickupTime, '@@/@@/@@@@ ' + featureToggle.timeFormat(this, false)).format('X')

      if (parseInt(currentTime) >= parseInt(startTimeStart) &&
        parseInt(currentTime) <= parseInt(allowTimeEnd)
      ) {
        return
      }

      if (this.$refs.sharedAllowedTime.showModal()) {
        this.$refs.sharedAllowedTime.showModal()
      }
    },
    getFlightStatus () {
      let self = this
      if (!self.isAirportPickup && !self.isAirportDropoff) { return }

      let date = moment(self.rsvp.pickupTime, 'MM/DD/YYYY ' + featureToggle.timeFormat(self, false))
      let airlineDate = encodeURIComponent(date.format('YYYY-MM-DD'))
      let airlineTime = encodeURIComponent(date.format('HH:mm:ss'))
      let flightNumber = self.rsvp.flightNumber || self.rsvp.dropoffFlightNumber
      let isDeparture = '&departure=0'
      if ((self.rsvp.airline === null || self.rsvp.airline === '') &&
        (self.rsvp.dropoffAirline !== null && self.rsvp.dropoffAirline !== '')
      ) {
        isDeparture = '&departure=1'
      }
      let url = '/availability/flights/' +
        self.rsvp.airlineCode + flightNumber +
        '?date=' + airlineDate +
        '&time=' + airlineTime +
        '&airport=' + self.rsvp.airportCode +
        isDeparture
      self.$sdk.get(self, url, {}, r => {
        if (r.error) {
          self.flightStatus = { label: 'On Time', class: 'ontime' }
          return
        }
        self.flightStatus = self.translateFlightStatus(r.status)
      })
    },
    setPickupTimeOffsets () {
      let self = this
      let PickupTimeOffsets = this.$settings.get('PickupTimeOffsets')
      if (PickupTimeOffsets) {
        let split = PickupTimeOffsets.split(',')
        split.forEach(function (val, index) {
          if (!self.offsets['a' + val.substring(0, 1)]) {
            self.offsets['a' + val.substring(0, 1)] = []
          }
          self.offsets['a' + val.substring(0, 1)].push({
            start: val.substring(1, 5),
            end: val.substring(5, 9),
            value: val.substring(9, val.length)
          })
        })
      }
    },
    addExtraStop () {
      let index = 0
      if (this.edited.extraStops && this.edited.extraStops.length) {
        index = this.edited.extraStops.length - 1
      }
      this.$store.commit('rsvpEdit/addExtraStop', {
        address1: '',
        address2: '',
        city: '',
        lat: '',
        lng: '',
        locationId: '',
        state: '',
        status: '',
        stopIndex: index,
        zipCode: ''
      })
      this.$forceUpdate()
      this.updateStopLocation(0)
    },
    openCharterDatePicker (field) {
      if (this.mtech.enabled) return

      // this.error.pickupTime = false
      this.$store.commit('reservation/setCharterData', {datePicker: field})
      this.$store.commit('rsvpEdit/showDateTimePicker')
    },
    optinPrice () {
      let selected = this.edited.serviceCode
      if (!selected || !Object.keys(this.services).length || !this.services[selected]) return 0

      let origPrice = this.services[selected].prices[(this.edited.passengers || 1) - 1].price
      let percent = this.services[selected].optinPercent / 100
      percent = parseFloat((1 - percent).toFixed(2))
      return origPrice * percent
    },
    optinRefundPrice () {
      let selected = this.edited.serviceCode
      if (!selected || !Object.keys(this.services).length) return 0

      let origPrice = this.services[selected].prices[(this.edited.passenger || 1) - 1].price
      return parseFloat((origPrice - this.optinPrice()).toFixed(2))
    },
    showGuest () {
      if (this.mtech.enabled || this.edited.isLyft) return
      this.$store.commit('rsvpEdit/showGuestInformation')
    },
    showDriverNotes () {
      if (this.mtech.enabled || this.edited.isLyft) return
      this.$store.commit('rsvpEdit/showDriverNotes')
    },
    rechkServiceBuffer () {
      // if (!this._serviceCode) return
      let selected = this._serviceCode || this.edited.serviceCode
      let service = this.services[selected]
      let nowPlusBuffer = moment().add(service.bufferTime, 'minutes')
      let pickupDate = moment(this.edited.pickupTime, 'MM/DD/YYYY hh:mmA')
      if (pickupDate.isBefore(nowPlusBuffer)) {
        this.$store.commit('rsvpEdit/setSelectedService', null)
        this.$store.commit('rsvpEdit/emptyEditedService', '')
      }
    },
    showCancellation () {
      this.$store.commit('rsvpEdit/setCancellationData', {
        show: true,
        type: 'edit'
      })
    }
  },
  watch: {
    _pickupTime: function (value) {
      this.sharedAllowedTime()
    },
    _airline: function (value) { this.checkSuggestedTime() },
    _flightNo: function (value) { this.checkSuggestedTime() },
    _suggestedTime: function (value) { this.checkSuggestedTime() },
    _serviceCode: function (value) {
      // let isShared = this.$store.state.rsvpEdit.serviceSelection.selectedService === 'shared'
      let currentService = value ? value.code : this.$store.state.rsvpEdit.editedRsvp.serviceCode
      currentService = currentService === 'shared'
      if (this.lastSelectedService !== currentService) {
        this.lastSelectedService = currentService
        this.checkSuggestedTime()
      }
    },
    _pickupTimeOffsets: function (value) { if (value) this.setPickupTimeOffsets() },
    quoteLoading () {
      this.optinKey = moment().format('x')
    }
  },
  mounted () {
    this.setPickupTimeOffsets()

    this.$store.commit('setCurrentIndex', -1)
    if (this.$store.state.rsvpEdit.originalRsvp === null) {
      this.$router.push('search')
      return
    }
    if (!this.edited.isLyft) {
      ApiQuote.getQuote(this)
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-font{ margin: 10px 0!important; }
.logo{
  text-align: center;
  margin: 10px 0;
  img { width: 250px; }
}

.rsvp-edit {
  & .title {
    text-align: center;
  }
}

.mtech-note{
  text-align: center;
  font-style: italic;
  margin-bottom: 15px;
  color: #555;
}

.label-value {
  position: relative;
  padding: 10px 0;
  border-bottom: 1px solid rgba(0,0,0,0.15);
  cursor: pointer;
  transition: all 250ms;
  -webkit-transition: all 250ms;
  background-color: #fff;

  &:hover{ background-color: #f5f5f5; }
  &.border-top { border-top: 1px solid rgba(0,0,0,0.15); }
  &.border-left { border-left: 1px solid rgba(0,0,0,0.15); }
  &.padding-left { padding-left: 10px; }
  &.no-pointer{
    cursor: default;
    background-color: #fff;
  }
  & .label {
    font-size: 12px;
    line-height: 12px;
    color: #777;

    & > *{
      display: inline-block;
      vertical-align: middle;
    }

    & i { margin-right: 5px; }
  }

  & .value {
    font-size: 16px;
    line-height: 16px;
    margin-top: 6px;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 20px;

    span{
      display: inline-block;
      min-height: 14px;
    }
  }

  & i.fa-edit {
    color: #777;
    position: absolute;
    right: 5px;
    top: 17px;
  }

  & i.fa-chevron-right {
    color: #777;
    position: absolute;
    right: 10px;
    top: 18px;
  }

  &.error .value { color: #F20D0D; }

  &.disabled {
    pointer-events: none;
    opacity: 0.7;
  }
}

.add-extra-stop{
  font-size: 14px;
  i{
    margin-right: 5px;
  }
}

.select-input {
  & select {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }

  & i.fa-caret-down {
    position: absolute;
    right: 10px;
    top: 18px;
    color: #777;
  }
}

.checkbox {
  & .value > * {
    display: inline-block;
    vertical-align: middle;
    margin-right: 3px;
  }

  & .checked { display: none; color: #26D97A; }
  & .unchecked { display: inline-block; }

  &.checked {
    & .checked { display: inline-block; }
    & .unchecked { display: none; }
  }
}

.op-btn {
  margin-top: 20px;
}

.cancel-rsvp-btn {
  margin-top: 10px;
}

.cancel-btn {
  margin-top: 5px;
  padding: 10px;
  display: block;
  text-align: center;
  color: #cb8112;
}

.error-modal {
  background-color: #fff;
  max-width: 350px;
  margin: 10px auto;
  padding: 20px;
  border-radius: 3px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);

  & .title {
    text-align: center;
    font-weight: 700;
    margin-bottom: 15px;
    color: #F20D0D;
  }

  & .message {
    text-align: center;
    margin-bottom: 15px;
  }
}

.suggested-time-box{
  max-width: 450px;
  width: 100%;
  margin: 10px auto;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  font-family: 'Questrial', sans-serif;
  text-align: center;
  position: relative;

  .box{
    width: 100%;
    padding: 15px;
    background-color: #fff;
    border-radius: 3px;

    &.active{
      top: 0;
    }
  }
  .title{
    font-size: 21px;
    font-weight: 600;
  }
  p{ margin-bottom: 10px; }
  .time{
    font-size: 21px;
    font-weight: 600;
    word-spacing: 5px;
    color: #3ac568;
    display: inline-block;
    border-bottom: 1px solid #7cf5a4;
  }
  .keep{
    color: #999!important;
    margin: 15px 0 5px;
    display: block;
    text-decoration: underline;
  }
}

.pickup-time{
  background: #f3f3f3;
  cursor: default;
  padding-left: 10px;
}

.opt-title{
  font-weight: 600;
}
.opt-desc{
  font-size: 14px;
}
.opt-check{
  font-size: 15px;
  cursor: pointer;
  input {
    margin-right: 5px;
    vertical-align: -1px;
    margin-top: 10px;
  }
}

.slide-down-enter-active, .slide-down-leave-active { transition: all .30s ease backwards; }
.slide-down-enter, .slide-down-leave-to {
  transform: translateY(-30px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// index.vue?2c8de1a2